const CODES = {
  DAILY_LOGIN: 'DAILY_LOGIN',
  COMPLETE_ONBOARDING_SURVEY: 'COMPLETE_ONBOARDING_SURVEY',
  TEXT_TO_SPEECH: 'TEXT_TO_SPEECH',
  CREATE_PROJECT: 'CREATE_PROJECT',
  SUBTITLE_TO_SPEECH: 'SUBTITLE_TO_SPEECH',
  CREATE_INSTANT_VOICE_CLONE: 'CREATE_INSTANT_VOICE_CLONE',
  REFER_A_FRIEND: 'REFER_A_FRIEND',
  REFER_A_FRIEND_TO_BUY_THEIR_FIRST_PACKAGE:
    'REFER_A_FRIEND_TO_BUY_THEIR_FIRST_PACKAGE',
  REFERRAL_CODE_APPLIED_SUCCESSFULLY: 'REFERRAL_CODE_APPLIED_SUCCESSFULLY',
  REFEREE_FIRST_PAID_ORDER: 'REFEREE_FIRST_PAID_ORDER',
};

const TASK_TYPE = {
  REFERRAL: 'REFERRAL',
  ONBOARDING: 'ONBOARDING',
};

export { CODES, TASK_TYPE };
